import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { slugify, kbygPaths } from '@surfline/web-common';

import SpotDetails from 'components/SpotDetails';
import SpotListCTAThumbnail from 'components/SpotListCTAThumbnail';
import SpotThumbnail from 'components/SpotThumbnail';
import WavetrakLink from 'components/WavetrakLink';
import spotPropType from 'propTypes/spot';
import unitsPropType from 'propTypes/units';

import styles from './SpotMarkerTooltip.module.scss';

const { spotReportPath } = kbygPaths;
const getBackgroundImg = (spot) => (spot.cameras[0] ? spot.cameras[0].stillUrl : null);

const SpotMarkerTooltip = ({
  spot,
  units,
  position = { vertical: 'top', horizontal: 'center' },
  showPremiumCamCTA = false,
}) => {
  const renderSpotThumbnail = showPremiumCamCTA ? (
    <SpotListCTAThumbnail spot={spot} isTooltip />
  ) : (
    <SpotThumbnail
      windDirection={spot.wind.direction}
      windSpeed={spot.wind.speed}
      units={units}
      hasCamera={spot.cameras.length > 0}
    />
  );

  const spotUrl = spot ? spotReportPath(slugify(spot.name), spot._id) : '#';

  return (
    <WavetrakLink
      className={classNames(
        styles.spotMarkerTooltip,
        styles[`spotMarkerTooltip--${position.vertical}${position.horizontal}`],
      )}
      href={spotUrl}
      style={{ backgroundImage: `url('${getBackgroundImg(spot)}')` }}
      title={`${spot.name} Surf Report & Forecast`}
    >
      {spot.cameras[0] ? renderSpotThumbnail : null}
      <SpotDetails spot={spot} units={units} />
    </WavetrakLink>
  );
};

SpotMarkerTooltip.propTypes = {
  spot: spotPropType.isRequired,
  units: unitsPropType.isRequired,
  position: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string,
  }),
  showPremiumCamCTA: PropTypes.bool,
};

export default SpotMarkerTooltip;
